<template>
  <div class="form-actions">
    <button type="button" @click="onCancel" class="btn btn-secondary">
      Cancel
    </button>
    <button 
      type="submit" 
      class="btn btn-primary" 
      :disabled="isSubmitting"
      id="submit-button"
    >
      {{ isSubmitting ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FormActions',
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel'],
  methods: {
    onCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  padding: 1rem 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-primary {
  background-color: #3b82f6;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #2563eb;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background-color: white;
  color: #4b5563;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}
</style> 